import React from 'react';
import './nobleIcon.scss';

function NobleIcon({ name, iconWrapperClass = '', ...rest }) {
	return (
		<div className={'NobleIcon ' + iconWrapperClass} {...rest}>
			<div className={'NobleIcon__' + name}></div>
		</div>
	);
}

export default NobleIcon;
